import { ForgotPasswordForm } from "@/features/auth/ui/ForgotPasswordForm";

export const ForgotPasswordRoute = () => {
    return <ForgotPasswordForm />;
};

